import request from '../utils/Request';
import { Methods } from '../config';
import { downloadFile } from '../utils/download';
import { generateReqBodyWithFiles } from '../utils/generateReqBodyWithFiles';

const baseURL = 'dynamicForm';

const dynamicFormService = {
  getAttendancePrefillVariables: () => request({
    method: Methods.GET,
    resource: `${baseURL}/attendance-prefill/variables`,
  }),

  prepareAttendanceWorksheet: (attendanceId) => request({
    method: Methods.POST,
    resource: `${baseURL}/attendance-prefill/${encodeURIComponent(attendanceId)}`,
  }),
  getFile: async (id, filename) => {
    const file = await request({
      responseType: 'blob',
      resource: `${baseURL}/getFile/${encodeURIComponent(id)}`,
    });
    return downloadFile(file, filename);
  },

  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  getItem: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  getWorksheet: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/worksheet/${encodeURIComponent(id)}`,
    });
  },

  getWorksheetEmailOptions: (projectId, dynamicFormId) => {
    const params = new URLSearchParams();
    if (projectId) params.set('projectId', projectId);
    if (dynamicFormId) params.set('dynamicFormId', dynamicFormId);
    const queryString = params.toString();
    const query = queryString ? `?${queryString}` : '';
    return request({
      method: Methods.GET,
      resource: `${baseURL}/worksheet/email-options${query}`,
    });
  },

  getSelectViews: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/select-views`,
    });
  },

  getWorksheetReportForms: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/worksheet-report/forms`,
    });
  },

  getWorksheetStatuses: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/worksheet-report/statuses`,
    });
  },

  getWorksheetReport: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/worksheet-report/${encodeURIComponent(id)}`,
    });
  },

  getWorksheetPdf: (headId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/worksheet-report/${encodeURIComponent(headId)}/pdf`,
      responseType: 'blob',
    });
  },

  updateWorksheetStatus: (headId, statusId) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/worksheet-report/${encodeURIComponent(headId)}/status`,
      data: { statusId },
    });
  },

  sendWorksheetEmail: (headId, data, files, assignedTemplateOnly = false) => {
    const formData = generateReqBodyWithFiles(data, files);
    return request({
      method: Methods.POST,
      resource: `${baseURL}/${assignedTemplateOnly ? 'worksheet' : 'worksheet-report'}/${encodeURIComponent(headId)}/email/send`,
      formData: true,
      data: formData,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  uploadFile: (id, files) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });
    return request({
      method: Methods.POST,
      resource: `${baseURL}/uploadFile/${encodeURIComponent(id)}`,
      formData: true,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  deleteFile: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/deleteFile/${encodeURIComponent(id)}`,
    });
  },

  addForm: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/addForm`,
      data,
    });
  },
};

export default dynamicFormService;
